import {Component} from '@angular/core';
import {LoginIdService} from "../../service/login-id.service";
import {Subscription} from "rxjs";
import {startWith} from "rxjs/operators";
import {Router} from "@angular/router";


@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {

    showContactSupportModal: boolean;
    mobile: boolean = false;
    isLoggedIn: boolean = false;

    loginStatusChanged: Subscription

    constructor(private router: Router,private loginIdService: LoginIdService) {
    }

    async ngOnInit(): Promise<void> {
        await this.loginIdService.loginServiceInitialized$.toPromise()

        this.loginStatusChanged = this.loginIdService.loginStatusChanged$.pipe(
                startWith(this.loginIdService.getLoginStatus())).subscribe(status => {
            this.isLoggedIn = status;
        });

        if (window.screen.width <= 1000) { // 768px portrait
            this.mobile = true;
        }
    }

    openContactModal() {
        this.showContactSupportModal = true;
    }

  async logout() {
    await this.loginIdService.loggedOut(true);
  }
}
